(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-advertorial-content"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Cards de testimonials: fade-in en orden aleatorio al entrar en viewport
  var cards = document.querySelectorAll('.u1-adv-content__tcard, .u1-adv-content__card');
  if (!cards.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;
  cards.forEach(function (c) { c.classList.add('tcard-hidden'); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var c = entry.target;
      c.style.setProperty('--tcard-delay', Math.round(Math.random() * 700) + 'ms');
      c.classList.add('tcard-in');
      c.classList.remove('tcard-hidden');
      io.unobserve(c);
    });
  }, { threshold: 0.15 });
  cards.forEach(function (c) { io.observe(c); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-advertorial-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-advo-drag]').forEach(function (el) {
    var down = false, startX = 0, startLeft = 0, moved = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false;
      startX = e.clientX; startLeft = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { moved = true; el.classList.add('is-dragging'); }
      el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      window.setTimeout(function () { el.classList.remove('is-dragging'); }, 50);
    });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
  });

  // Dots de la galeria: uno por slide, sync con el scroll, click navega
  document.querySelectorAll('[data-advo-dots]').forEach(function (dots) {
    var strip = dots.previousElementSibling;
    if (!strip || !strip.hasAttribute('data-advo-drag')) return;
    var frames = strip.children;
    if (frames.length < 2) { dots.style.display = 'none'; return; }
    for (var i = 0; i < frames.length; i++) {
      (function (idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'u1-adv-offer__dot' + (idx === 0 ? ' is-active' : '');
        b.addEventListener('click', function () {
          strip.scrollTo({ left: frames[idx].offsetLeft - strip.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      })(i);
    }
    var sync = function () {
      var idx = Math.round(strip.scrollLeft / strip.clientWidth);
      idx = Math.max(0, Math.min(idx, frames.length - 1));
      for (var j = 0; j < dots.children.length; j++) {
        dots.children[j].classList.toggle('is-active', j === idx);
      }
    };
    strip.addEventListener('scroll', sync, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.u1-collection-grid').forEach(function (root) {
      var scroller = root.querySelector('.u1-collection-grid__scroller');
      var dotsWrap = root.querySelector('[data-u1-cg-dots]');
      if (!scroller || !dotsWrap) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('.u1-collection-grid__card'));
      if (cards.length < 2) return;

      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'u1-collection-grid__dot' + (i === 0 ? ' is-active' : '');
        dot.addEventListener('click', function () {
          scroller.scrollTo({ left: card.offsetLeft - scroller.offsetLeft - 24, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
      var dots = Array.prototype.slice.call(dotsWrap.children);

      var ticking = false;
      function paint() {
        var x = scroller.scrollLeft + scroller.clientWidth * 0.25;
        var idx = 0;
        cards.forEach(function (card, i) { if (card.offsetLeft - cards[0].offsetLeft <= x) idx = i; });
        /* Al fondo del scroll: siempre la ultima */
        if (scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 4) idx = cards.length - 1;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
      scroller.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; paint(); });
      }, { passive: true });
      paint();
    });

    /* ── Modal de comparacion ── */
    document.querySelectorAll('.u1-collection-grid').forEach(function (root) {
      var modal = root.querySelector('[data-u1-cg-compare]');
      var openBtn = root.querySelector('[data-u1-cg-compare-open]');
      if (!modal || !openBtn) return;
      function setOpen(open) {
        modal.hidden = !open;
        document.documentElement.style.overflow = open ? 'hidden' : '';
      }
      openBtn.addEventListener('click', function () { setOpen(true); });
      modal.querySelectorAll('[data-u1-cg-compare-close]').forEach(function (el) {
        el.addEventListener('click', function () { setOpen(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) setOpen(false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-multicolumn"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Cascada: cada columna recibe un delay creciente para el reveal focus-blur
       (el snippet lee data-u1-reveal-delay al momento de animar, asi que basta
       setearlo antes de que la columna entre al viewport). Base 160ms para que
       entre despues del header (0) y el subheadline (120). */
    if (window.__u1McStaggerInit) return;
    window.__u1McStaggerInit = true;
    document.querySelectorAll('[data-u1-mc-track]').forEach(function (track) {
      Array.prototype.forEach.call(track.children, function (col, i) {
        if (!col.hasAttribute('data-u1-reveal-focus-blur') || col.hasAttribute('data-u1-reveal-delay')) return;
        col.setAttribute('data-u1-reveal-delay', String(160 + i * 120));
      });
    });
  })();
  (function () {
    if (window.__u1McCarouselInit) return;
    window.__u1McCarouselInit = true;
    document.querySelectorAll('[data-u1-mc-track]').forEach(function (track) {
      var section = track.closest('section') || track.parentElement;
      if (!section || section.dataset.u1McInit) return;
      var prevBtn = section.querySelector('[data-u1-mc-prev]');
      var nextBtn = section.querySelector('[data-u1-mc-next]');
      if (!prevBtn && !nextBtn) return;
      section.dataset.u1McInit = '1';
      function getGap() { return parseFloat(window.getComputedStyle(track).columnGap) || 20; }
      function step() { var c = track.children[0]; return (c ? c.offsetWidth : 300) + getGap(); }
      function updateArrows() {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
      }
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
      if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-u1-sticky-bar]').forEach(function (bar) {
    var after = parseInt(bar.getAttribute('data-show-after'), 10) || 150;
    var anchorId = bar.getAttribute('data-anchor');
    var keepOnFooter = bar.getAttribute('data-keep-on-footer') === '1';
    var footerInView = false;
    var anchorPassed = false;

    // El ancla se resuelve por id, o por data-attribute si alguien puso el nombre a mano
    var anchorEl = null;
    if (anchorId) {
      anchorEl = document.getElementById(anchorId) || document.querySelector('[data-u1-anchor="' + anchorId + '"]');
    }

    var update = function () {
      var scrolled = window.scrollY > (after / 100) * window.innerHeight;
      // Con ancla y scroll configurados gana el primero que se cumpla
      var should = scrolled || anchorPassed;
      bar.classList.toggle('is-visible', should && !(footerInView && !keepOnFooter));
    };

    if (anchorEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting && en.boundingClientRect.top < 0) { anchorPassed = true; }
        });
        update();
      }, { threshold: 0 }).observe(anchorEl);
    }

    // Se retira antes de tapar el footer (legal o del sitio)
    if (!keepOnFooter) {
      var footer = document.querySelector('.u1-legal-footer') || document.querySelector('.u1-footer');
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { footerInView = en.isIntersecting; });
          update();
        }, { rootMargin: '0px 0px -10% 0px' }).observe(footer);
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-tabs-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.u1-tabs-menu').forEach(function (menu) {
      var pill = menu.querySelector('.u1-tabs-menu__pill');
      var thumb = menu.querySelector('[data-u1-tabs-menu-thumb]');
      var tabs = Array.prototype.slice.call(menu.querySelectorAll('.u1-tabs-menu__tab'));
      var wrap = menu.closest('.u1-tabs-menu-sticky-wrap') || menu.parentElement;
      var nav = document.querySelector('.u1-navbar[data-u1-navbar]');

      /* ── Thumb deslizante ── */
      function moveThumb(instant) {
        var active = menu.querySelector('.u1-tabs-menu__tab.is-active');
        if (!active || !thumb) return;
        if (instant) thumb.style.transition = 'none';
        thumb.style.width = active.offsetWidth + 'px';
        thumb.style.transform = 'translateX(' + active.offsetLeft + 'px)';
        if (instant) requestAnimationFrame(function () { thumb.style.transition = ''; });
      }
      function setActive(tab) {
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        moveThumb(false);
      }
      window.addEventListener('resize', function () { moveThumb(true); });
      moveThumb(true);

      /* ── Click: activo + scroll suave a anchor ──
         spyLock: mientras viaja el scroll, el scrollspy queda suspendido para
         que el thumb vaya DIRECTO a la tab elegida sin frenar en las intermedias. */
      var spyLockTarget = null;
      var spyLockUntil = 0;
      /* ── Modo filtro: en vez de scrollear, esconde/muestra cards por producto ── */
      var filterTarget = (menu.getAttribute('data-u1-tm-filter-target') || '').trim();
      function applyFilter(tab) {
        var cont = null;
        try { cont = document.querySelector(filterTarget); } catch (_e) { return; }
        if (!cont) return;
        var want = tab.getAttribute('data-u1-tabs-menu-filter') || '';
        cont.querySelectorAll('[data-u1-card-product]').forEach(function (c) {
          c.style.display = (!want || c.getAttribute('data-u1-card-product') === want) ? '' : 'none';
        });
        var track = cont.querySelector('.u1-carousel__track') || cont;
        try { track.scrollTo({ left: 0, behavior: 'smooth' }); } catch (_e2) { try { track.scrollLeft = 0; } catch (_e3) {} }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          setActive(tab);
          if (filterTarget) {
            e.preventDefault();
            applyFilter(tab);
            return;
          }
          if (!tab.hasAttribute('data-u1-tabs-menu-hash')) return;
          var hash = tab.getAttribute('href') || '';
          if (hash.length < 2) return;
          var target = null;
          try { target = document.querySelector(hash); } catch (_e) { return; }
          if (!target) return;
          e.preventDefault();
          var offset = menu.offsetHeight + 16;
          var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
          spyLockTarget = y;
          spyLockUntil = performance.now() + 2000;
          window.scrollTo({ top: y, behavior: 'smooth' });
          if (history.pushState) history.pushState(null, '', hash);
        });
      });

      /* ── Scrollspy: la tab activa sigue a la section visible ── */
      var spyPairs = tabs
        .filter(function (t) { return t.hasAttribute('data-u1-tabs-menu-hash'); })
        .map(function (t) {
          var el = null;
          try { el = document.querySelector(t.getAttribute('href')); } catch (_e) {}
          return el ? { tab: t, el: el } : null;
        })
        .filter(Boolean);

      /* ── Sticky + swap con la nav (mismo patron que el Super menu):
         pegada = tabs visibles y nav oculta, sin importar la direccion;
         la nav solo vuelve al despegarse (de vuelta en el hero). ── */
      function isStuck() {
        return wrap.getBoundingClientRect().top <= 0.5;
      }
      function setNavHidden(hide) {
        if (!nav) return;
        nav.classList.toggle('u1-tm-nav-hidden', hide);
      }
      function updateSpy() {
        if (!spyPairs.length) return;
        if (spyLockTarget !== null) {
          /* Suspendido hasta llegar (o hasta que venza el lock por las dudas) */
          var arrived = Math.abs(window.pageYOffset - spyLockTarget) < 4;
          if (!arrived && performance.now() < spyLockUntil) return;
          spyLockTarget = null;
          if (arrived) return;
        }
        var line = menu.offsetHeight + 24;
        var current = null;
        spyPairs.forEach(function (p) {
          if (p.el.getBoundingClientRect().top <= line) current = p.tab;
        });
        if (current && !current.classList.contains('is-active')) setActive(current);
      }
      /* La nav se esconde ANTES de que las tabs se peguen (zona de despeje);
         las tabs solo existen pegadas: fade-in al stick, fade-out al volver. */
      var NAV_ZONE = 240;
      function update() {
        updateSpy();
        var top = wrap.getBoundingClientRect().top;
        setNavHidden(top <= NAV_ZONE);
        wrap.classList.toggle('u1-tm--stuck', top <= 0.5);
      }

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
